<script setup>
import { ref, onMounted, nextTick } from 'vue'; // Vue 组合式 API
import { useStore } from 'vuex'; // 引入 Vuex store
import axios from 'axios'; // 引入 Axios 进行 HTTP 请求
// import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'; // 引入 Mapbox
// import "mapbox-gl/dist/mapbox-gl.css"; // 引入 Mapbox 样式
import AMapLoader from '@amap/amap-jsapi-loader';

// 引入组件
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import ArgData from "@/views/components/ArgData.vue";

// 引入 API 方法
import {deviceList, deviceTsl, groupDeviceList, getDeviceLastData ,signData} from "@/api/device";
import { statistics } from "@/api/home";
import { groupPage } from "@/api/group";
import { parseTime } from "@/utils/ruoyi";
import {getToken,getStoredRefreshToken} from "@/utils/auth";

// 使用 Vuex Store
const store = useStore();

// 定义数据 refs
const groupList = ref([]); // 组列表
const newGroupList = ref([]); // 处理后的组列表，包含设备信息
const markers = ref([]); // 地图标记数据
const statisticsList = ref({}); // 统计数据
const activeNames = ref([]); // 当前激活的组名称
const currentDevice = ref({}); // 当前选中的设备
const list = ref([]); // 设备列表
const currentDeviceData = ref([]); // 当前设备的数据
const signDataObj = ref({}); // 标识数据对象
const map = ref(null)
const mapContainer = ref(null)
const deviceListData = ref([])
const tclPropertieList = ref([]) // 当前设备物模型列表
const newCurrentData = ref({}) // 通过物模型过滤后的实时属性数据
// 获取组列表
const getGroupList = () => {
  groupPage({}).then(res => {
    if (res && res.data && res.data.list) {
      groupList.value = res.data.list; // 设置组列表数据

      getDeviceList({pageSize: 100})

      // if(groupList.value && groupList.value.length === 0){
      //   getDeviceList({pageSize: 100})
      // }
      getGroupDevice(); // 获取组内设备信息
    }
  });
};

// 获取默认组的100条数据
// 获取设备列表
const getDeviceList = (params) => {
  deviceList(params).then(res => {
    console.log('deviceListData res', res)
    if(res && res.data && res.data.list){
      deviceListData.value = res.data.list
      console.log(' = deviceListData', deviceListData.value)
    }

  })
}

// 获取组内设备信息
const getGroupDevice = async () => {
  newGroupList.value = await Promise.all(
      groupList.value.map(async item => {
        const deviceListResponse = await groupDeviceList({ groupId: item.id });
        return {
          ...item,
          deviceList: deviceListResponse // 为每个组添加对应的设备列表
        };
      })
  );
};

// 获取统计数据
const getStatistics = () => {
  statistics().then(res => {
    if(res && res.data){
      statisticsList.value = res.data; // 设置统计数据
    }

  }).catch(err => {
    console.error('获取统计数据失败', err);
  });
};

// 初始化地图
const initMap = async () => {
  // 获取用户当前位置信息
  // const response = await axios.get('https://ipapi.co/json/');
  // const { longitude, latitude } = response.data;

  // 高德api调用
  AMapLoader.load({
    key: "32f050974b138cc3c0dcfe8d9db6dcd5",
    version: "1.4.15",
    plugins: ['AMap.ToolBar', 'AMap.Scale', 'AMap.OverView', 'AMap.DistrictSearch'],
    customApi: "https://webapi.amap.com/maps",
  }).then((AMap) => {
    mapContainer.value = new AMap.Map("mapContainer", {
      viewMode: "2D",
      zoom: 5,
      lang: 'zh_en',
    });

    // 添加 marker 并存储为数组
    const markerList = markers.value.map(item => {
      return new AMap.Marker({
        position: [item.lng, item.lat],
        map: mapContainer.value,
        label: {
          content: item.label,
          offset: new AMap.Pixel(10, -20),
        }
      });
    });

    // ✅ 不要用 map.add(markerList)，用 marker.setMap(map)
    // 所有 marker 已添加到 map，无需再额外 add()

    // ✅ 延迟执行 setFitView，确保 marker 已全部添加
    mapContainer.value.setFitView(markerList); // 传入 marker 数组以自适应视图

    // ❌ 不要再调用 setZoomAndCenter，会覆盖 setFitView 效果
    // 如果你需要默认展示某个点，直接设置地图初始化 center 即可：
    // center: markers.value[0].position,
  });


  // // 设置 Mapbox Access Token
  // mapboxgl.accessToken = "pk.eyJ1Ijoiczk5dDMiLCJhIjoiY20yaDR5NDN5MDh3aTJ3c2I1bWhpaTNoZyJ9.fD7WVkrTt8Vl-GrOv1MjTg";
  //
  // // 初始化 Mapbox 地图
  // let map = new mapboxgl.Map({
  //   container: "map", // 地图容器 ID
  //   style: "mapbox://styles/mapbox/streets-v11", // 地图样式
  //   center: [longitude, latitude], // 设置地图中心点为用户当前定位
  //   zoom: 10 // 初始缩放级别
  // });
  //
  // // 添加标记到地图上，并应用不同的偏移量
  // markers.value.forEach((marker, index) => {
  //   const offset = 0.0001 * index; // 设置偏移量
  //   const adjustedLng = marker.lng + offset;
  //   const adjustedLat = marker.lat + offset;
  //
  //   // 添加标记
  //   new mapboxgl.Marker()
  //       .setLngLat([adjustedLng, adjustedLat])
  //       .addTo(map);
  //
  //   // 创建并添加标记标签
  //   const label = document.createElement('div');
  //   label.className = 'marker-label';
  //   label.textContent = marker.label;
  //
  //   new mapboxgl.Marker(label)
  //       .setLngLat([adjustedLng, adjustedLat])
  //       .addTo(map);
  // });
  //
  // // 添加地图控件
  // // map.addControl(new MapboxLanguage({ defaultLanguage: 'zh' }));
  // map.addControl(new mapboxgl.FullscreenControl());
  // map.addControl(new mapboxgl.NavigationControl());
  // map.addControl(new mapboxgl.ScaleControl({ maxWidth: 100, unit: "metric" }));
  //
  // return map;
};

// 处理组切换
const handleChange = (val) => {
  // 处理组切换逻辑
};

// 偏移逻辑函数
const getOffset = (index) => {
  const factor = 0.001; // 偏移系数，可以根据实际需求调整
  const lngOffset = (Math.random() - 0.5) * factor; // 经度偏移，范围：[-factor/2, factor/2]
  const latOffset = (Math.random() - 0.5) * factor; // 纬度偏移
  return { lng: lngOffset, lat: latOffset };
};

// 获取设备列表
const getList = async (params) => {
  try {
    const res = await deviceList(params); // 等待设备列表数据请求完成

    if (res && res.data && res.data.list) {
      list.value = res.data.list; // 设置设备列表
      currentDevice.value = res.data.list[0]; // 设置默认选中设备

      // 添加设备标记到地图
      markers.value = res.data.list.map((item, index) => {
        const offset = getOffset(index); // 获取偏移值
        return {
          lng: item.longitude || 114.48,
          lat: item.latitude || 36.6,
          label: item.deviceName || '--'
        };
      });

      await initMap(); // 初始化地图

      console.log(' = res.data.list = = = =', res.data.list, 'markers : ', markers.value);

      // 获取当前设备数据
      if(currentDevice.value){
        await getLatestData({ deviceName: currentDevice.value.deviceName }); // 等待最新设备数据获取完成
      }
    }
  } catch (error) {
    console.error('Error in getList:', error);
  }
};


// 获取最新设备数据
const getLatestData = async (params) => {
  try {
    // 获取物模型
    const deviceTslRes = await deviceTsl(params);
    tclPropertieList.value = deviceTslRes.data.propertie;
    console.log(' = res tclPropertieList', tclPropertieList.value);

    // 获取当前设备属性列表
    const latestDataRes = await getDeviceLastData(params.deviceName);
    if (latestDataRes && latestDataRes.data) {
      currentDeviceData.value = latestDataRes.data; // 设置当前设备数据
      console.log(' = 修改的数据', currentDeviceData.value)
      const resSignData = await signData(Object.keys(latestDataRes.data))
      signDataObj.value = resSignData.data
    }

    // 遍历物模型 通过物模型过滤 除最新数据
    newCurrentData.value = {}
    for (const key in currentDeviceData.value) {
      tclPropertieList.value.forEach((item) => {

        if(key === item.identifier) {
          newCurrentData.value[key] = currentDeviceData.value[key]
          newCurrentData.value[key].unit = item.elementUnit
          newCurrentData.value[key].name = item.functionName
        }
      })
    }
    console.log(' = newCurrentData = = =', newCurrentData.value)

  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

// 获取标识数据
// const getSignData = (list) => {
//   signData(list).then(res => {
//     signDataObj.value = res.data; // 设置标识数据
//     console.log(' = signDataObj', signDataObj.value)
//   });
// };

// 选择设备
const selectDevice = (it) => {
  currentDevice.value = it; // 设置当前选中的设备
  if (currentDevice.value && currentDevice.value.deviceName) {
    getLatestData({ deviceName: currentDevice.value.deviceName }); // 获取选中设备的数据
  }
};


// 获取物模型
const getDeviceTsl = (params)=>{
  deviceTsl(params).then(res=>{
    tclPropertieList.value = res.data.propertie
    console.log(' = res tclPropertieList', tclPropertieList.value)
  })
}



// 组件挂载时执行
onMounted(() => {
  getGroupList(); // 获取组列表
  getStatistics(); // 获取统计数据
  getList({}); // 获取设备列表
  store.dispatch('setUserInfo');
  nextTick(() => {
    // initMap(); // 初始化地图
    // if(mapContainer.value){
    //
    // }
  });
});

</script>
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12" v-if="statisticsList">
            <mini-statistics-card
              :title="$t('home.deviceSum')"
              :value="{text: statisticsList.deviceCount, color: '#cccccc'}"
              description="<span
                class='text-sm font-weight-bolder text-success'
                >+55%</span> since yesterday"
              :icon="{
                component: 'ni ni-support-16',
                background: 'bg-gradient-primary',
                shape: 'rounded-circle',
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card
              :title="$t('home.onlineDevice')"
              :value="{text: statisticsList.onlineCount, color: '#cccccc'}"
              description="<span
                class='text-sm font-weight-bolder text-success'
                >+3%</span> since last week"
              :icon="{
                component: 'ni ni-world',
                background: 'bg-gradient-success',
                shape: 'rounded-circle',
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card
              :title="$t('home.alarmQuantity')"
              :value="{text: statisticsList.todayAlarmCount, color: '#cccccc'}"
              description="<span
                class='text-sm font-weight-bolder text-danger'
                >-2%</span> since last quarter"
              :icon="{
                component: 'ni ni-paper-diploma',
                background: 'bg-gradient-danger',
                shape: 'rounded-circle',
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card
              :title="$t('home.offDevice')"
              :value="{text: statisticsList.offlineCount, color: '#cccccc'}"
              :icon="{
                component: 'ni ni-laptop',
                background: 'bg-gradient-warning',
                shape: 'rounded-circle',
              }"
            />

          </div>
        </div>
        <div class="row d-flex">
          <div class="col-lg-3 mb-lg">
            <!-- line chart -->
            <div class="card z-index-2">
              <div class="card-header border-bottom d-flex justify-content-between">
                <div>{{$t('home.deviceList')}}</div>
                <div>

                </div>
              </div>
              <div class="card-body">
                <div class="map-div">
                  <el-collapse v-model="activeNames" @change="handleChange" >

<!--
 6月10号
 临时处理，显示默认组
 源代码
                   <el-collapse-item v-if="newGroupList && newGroupList.length === 0" :title="$t('group.defaultGroup')" >
 -->
                    <el-collapse-item :title="$t('group.defaultGroup')" >

                      <div v-if="deviceListData && deviceListData.length > 0">
                        <div v-for="(it,idx) in deviceListData" :key="idx" class="row device-item d-flex align-items-center p-1" @click="selectDevice(it)">
                          <div class="col-3 d-flex align-items-center justify-content-center">
                            <div class="device-state" :style="{backgroundColor: it.state ? '#eee' : '#089B5C' }"></div>
                          </div>
                          <div class="col-9 overflow-auto"  v-if="it && it.noteName">{{it.noteName || '--'}}</div>
                        </div>
                      </div>
                      <el-empty v-else :image-size="50" :description="$t('home.groupNoDevice')"></el-empty>
                    </el-collapse-item>

                    <div v-if="newGroupList && newGroupList.length > 0">
                      <el-collapse-item  :title="item.groupName" :name="index" v-for="(item,index) in newGroupList" :key="index">
                        <div v-if="item && item.deviceList && item.deviceList.data && item.deviceList.data.length > 0">
                          <div v-for="(it,idx) in item.deviceList.data" :key="idx" class="row device-item d-flex align-items-center p-1" @click="selectDevice(it)">
                            <div class="col-3 d-flex align-items-center justify-content-center">
                              <div class="device-state" :style="{backgroundColor: it.state ? '#eee' : '#089B5C' }"></div>
                            </div>
                            <div class="col-9 overflow-auto"  v-if="it && it.noteName">{{it.noteName || '--'}}</div>
                          </div>
                        </div>
                        <el-empty v-else :image-size="50" :description="$t('home.groupNoDevice')"></el-empty>

                      </el-collapse-item>
                    </div>


                  </el-collapse>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 mb-lg">
<!--            <carousel />-->
            <div class="card">
              <div class="card-header border-bottom">{{$t('home.map')}}</div>
              <div class="card-body">
<!--                <div class="map-div" ref="map" id="map"></div>-->
                <div class="map-div" ref="mapContainer" id="mapContainer"></div>
              </div>
            </div>

          </div>
          <div class="col-lg-3 mb-lg">
            <!-- line chart -->
            <div class="card h-100 z-index-2">
              <div class="card-header border-bottom">{{$t('home.deviceInfo')}}</div>
              <div class="card-body">
                <el-descriptions title="" :column="1">
                  <el-descriptions-item :label="$t('home.deviceName')" label-align="right">{{currentDevice.deviceName}}</el-descriptions-item>
                  <el-descriptions-item :label="$t('device.noteName')" label-align="right">{{currentDevice.noteName}}</el-descriptions-item>
                  <el-descriptions-item :label="$t('home.groupId')">{{currentDevice.groupId}}</el-descriptions-item>
                  <el-descriptions-item :label="$t('home.onlineState')" v-if="currentDevice && currentDevice.onlineState">{{currentDevice.onlineState == 0 ? $t('home.offLine') : $t('home.onLine')}}</el-descriptions-item>
                  <el-descriptions-item :label="$t('home.deviceOffTime')">{{parseTime(currentDevice.offlineTime)}}</el-descriptions-item>
                  <el-descriptions-item :label="$t('home.deviceOnlineTime')">{{parseTime(currentDevice.onlineTime)}}</el-descriptions-item>
                  <el-descriptions-item :label="$t('home.createTime')">{{parseTime(currentDevice.createTime)}}</el-descriptions-item>
                </el-descriptions>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-12 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header border-bottom">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">{{$t('home.featureInfo')}}</h6>
                </div>
              </div>
              <div class="card-body">

                <!--采集器-->
                <div class="" v-if="newCurrentData">
                  <arg-data :deviceName="currentDevice.deviceName" :argList="newCurrentData" :argObj="signDataObj"></arg-data>
                </div>
                <div v-else>
                  <el-empty :description="$t('home.noData')" />
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.font-20 {
  font-size: 30px;
}
.map-div {
  width: 100%;
  height: 300px;
  //z-index: 9999;
  overflow: auto;
}

.device-state {
  width: 10px;
  height: 10px;
  border: 1px solid #ccc;
  border-radius: 50%;
}

.device-item {

}
.device-item:hover {
  background-color: #eeeeee;
}

.marker-label {
  background-color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: bold;
  color: black;
  white-space: nowrap;
  pointer-events: none; /* 防止标签干扰鼠标事件 */
  transform: translate(-50%, 0); /* 调整标签位置 */
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
}

</style>
